import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { AspectRatio } from "../../../aspect-ratio";
import { TransparentLayer } from "../expressive/common/Common.styles";
import { ImageContainer, ProductiveTileContainer } from "./Productive.styles";
import { Label } from "./Label.styles";
import { ImageWrapper } from "./ImageWrapper.styles";
export function ProductiveTile({ label, image, imageTitle, type, imageAspectRatio = "4:3", onSelect, altText, children, selected, imageStyles = { size: "contain", repeat: false }, }) {
    const [focused, setFocused] = useState(false);
    return (_jsxs(ProductiveTileContainer, Object.assign({ selected: selected, onMouseDown: () => setFocused(false), onKeyDown: (event) => {
            setFocused(false);
            if (event.key === "Enter" ||
                event.key === "Space" ||
                event.key === " ") {
                event.preventDefault();
                if (onSelect) {
                    onSelect();
                }
            }
        }, onKeyUp: () => setFocused(true), onBlur: () => setFocused(false), focused: focused, tabIndex: 0, scaleOnHover: type.includes("tlpa1"), type: type, onClick: () => {
            if (onSelect) {
                onSelect();
            }
        }, "data-testid": "prod-tile-id" }, { children: [_jsx("div", Object.assign({ className: "aspect-ratio-wrapper" }, { children: _jsx(AspectRatio, Object.assign({ ratio: type === "tlpa2" ? "1:1" : imageAspectRatio }, { children: _jsx(ImageContainer, Object.assign({ className: "image-container" }, { children: _jsx(ImageWrapper, Object.assign({ type: type, role: "img", imageStyles: imageStyles, "aria-label": altText, imageSource: image, title: imageTitle }, { children: _jsx(TransparentLayer, {}) })) })) })) })), children || _jsx(Label, Object.assign({ type: type }, { children: label }))] })));
}
